import { useQuery } from '@tanstack/react-query'
import { sortBySequenceNumber } from 'shared/lib/common-util'
import { QueryKeys } from '../../../key-registry'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { Document } from '../../document/models/types'
import { fetchHouseConsignmentDocumentsV3 } from './http'

export async function fetchHouseConsignmentDocuments(id: number, opts?: { signal?: AbortSignal }): Promise<Document[]> {
  const responses = await fetchHouseConsignmentDocumentsV3({ houseConsignmentId: id }, opts)
  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}

export function useFetchHouseConsignmentDocuments(houseConsignmentId: number | null) {
  return useQuery({
    queryKey: QueryKeys.houseConsignmentDocument.byHouseConsignmentId(houseConsignmentId),
    queryFn: ({ signal }) => fetchHouseConsignmentDocuments(houseConsignmentId as number, { signal }),
    enabled: !!houseConsignmentId,
  })
}
